import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { isAuthenticated } from "./index";
import { signinPathFor } from "./postAuthRedirect";

const PrivateRoute = ({ 
    redirectPath = '/signin',
    children,
}) => {

    let location = useLocation()
 if (!isAuthenticated()) {
     // Every protected page (path + query + hash) is restored after sign in.
     return  <Navigate
        to={redirectPath === '/signin' ? signinPathFor(location) : redirectPath} replace state={{ from: location }}
     />;
} 
    <Outlet />
 return children;
}
    

export default PrivateRoute;
